export enum SignatureType {
  SignatureArray,
  SignatureArrayManual,
  ApprovalSignature,
}
